module.exports = "<div class=\"blank\" fusePerfectScrollbar>\n\n    <fuse-invoice [order]=\"order\" [transactions]=\"transactions\" [dueAmount]=\"dueAmount\"></fuse-invoice>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /usr/app/src/app/main/content/app/facture/facture.component.html
// module id = ../../../../../src/app/main/content/app/facture/facture.component.html
// module chunks = main